import { useEffect, useState } from 'react';
import { Box, TextField, MenuItem, Typography, Button, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
//
import { useUnload } from 'hooks/useUnload';
import { ProductCategory } from 'types/product';
import { createProductCategory, getProductCategory, updateProductCategory } from 'services/ProductService';

export interface addCategoryProps {
    id?: string;
    onClose: () => void;
    label: string;
    refreshData: () => void;
}

const TitleText = styled(Typography)({
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    textAlign: 'left',
    margin: 0,
    marginTop: '20px',
    marginBottom: '6.5px'
});

const ButtonStyle = styled(Button)(({ theme }) => ({
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    width: '390px',
    height: '44px',
    color: `${theme.palette.primary.light} !important`
}));

const AddProductCategory = (props: addCategoryProps) => {
    const { id, label, onClose, refreshData } = props;
    const [productCategory, setproductCategory] = useState<ProductCategory>({
        id: '',
        name: ''
    });
    const [valueStatus, setValueStatus] = useState<number>(0); // 1: Data received, 2: Data changed in local, 0: None received
    const [saveButtonText, setSaveButtonText] = useState<string>('save');

    useEffect(() => {
        if (id) {
            getProductCategory(id, setproductCategory);
            setSaveButtonText('updating');
        }
    }, [id]);

    useUnload((e: any) => {
        const confirmationMessage = 'Are you sure?/';
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
    }, valueStatus === 2);

    const disabledSave: boolean = productCategory.name === '';

    const saveCategory = async () => {
        if (id) {
            const response = await updateProductCategory(productCategory);
            if (response === 201) {
                onClose();
                refreshData();
            }
        } else {
            const response = await createProductCategory(productCategory);
            if (response === 201) {
                onClose();
                refreshData();
            }
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
            <Box>
                <TitleText variant="h3">
                    <FormattedMessage id={label} />
                </TitleText>
                <TextField
                    onChange={(e) => setproductCategory({ ...productCategory, name: e.target.value.trimStart() })}
                    id="outlined-basic1"
                    sx={{ marginTop: '58px' }}
                    fullWidth
                    value={productCategory.name}
                    label={<FormattedMessage id="category-name" />}
                />
            </Box>
            <Box mt={4}>
                <ButtonStyle disabled={disabledSave} onClick={saveCategory} variant="contained">
                    <FormattedMessage id={saveButtonText} />
                </ButtonStyle>
            </Box>
        </Box>
    );
};

export default AddProductCategory;
